import React from 'react';

export default function Gallery() {
  return (
    <main className="section-container py-16">
      <h2 className="text-3xl font-semibold text-brand">Gallery</h2>
      <p className="mt-4 text-neutral/70">
        Images from Dr. Priya's practice and conferences can be added here.
      </p>
    </main>
  );
}
